import { request } from '../request'
import { CustomerWriterAccess } from '../types'

interface CustomerWriterAccessUpdates {
  access: string;
}

export class CustomerWriterAccessesService {

  // Keep method in a general format in case it changes in the future
  updateCustomerWriterAccess(writerId: number, customerId: number, updates: CustomerWriterAccessUpdates): Promise<CustomerWriterAccess> {
    return request.put(`/api/customer_writer_accesses/change_access.json`, { writerId, customerId, access: updates.access })
  }

  updateCustomerWriterAccessForAccount(writerId: number, updates: CustomerWriterAccessUpdates): Promise<CustomerWriterAccess> {
    return request.put(`/api/customer_writer_accesses/change_account_access.json`, { writerId, access: updates.access })
  }

  getCustomerWriterAccess(writerId: number, customerId: number): Promise<CustomerWriterAccess> {
    return request.get(`/api/customer_writer_accesses/writers/${writerId}/customers/${customerId}.json`)
  }

  getCustomerWriterAccessForAccount(writerId: number): Promise<CustomerWriterAccess> {
    return request.get(`/api/customer_writer_accesses/writers/${writerId}/account.json`)
  }

  getAllCustomerWriterAccesses(writerId: number): Promise<CustomerWriterAccess[]> {
    return request.get(`/api/customer_writer_accesses/writers/${writerId}.json`)
  }
}
